import { Components } from "appworks/components/components";
import { FadeOut } from "appworks/graphics/animation/base-animations";
import { SpineContainer } from "appworks/graphics/pixi/spine-container";
import { UIFlag, uiFlags } from "appworks/ui/flags/ui-flags";
import { Contract } from "appworks/utils/contracts/contract";
import { Parallel } from "appworks/utils/contracts/parallel";
import { Sequence } from "appworks/utils/contracts/sequence";
import { DMFNightModeComponent } from "components/dmf-nightmode-component";
import { EpicUIColourComponent } from "epic/components/epic-ui-colour-component";
import { gameLayers } from "game-layers";
import { TGRExitFreespins } from "states/freespins/tgr-exit-freespins";

export class DMFExitFreespins extends TGRExitFreespins {

    public onExit(): void {
        const fsSpine: SpineContainer = gameLayers.Background.getSpine("fs_spine");

        new Sequence([
            () => new Parallel([
                () => FadeOut(fsSpine, 1000),
                () => Components.get(DMFNightModeComponent).nightMode(false, 1000),
                () =>  Components.get(EpicUIColourComponent).resetAdjustmentFade(1000)
            ]),
            () => Contract.wrap(() => {
                uiFlags.set(UIFlag.IDLE, true);
                fsSpine.stop();
                fsSpine.visible = false;
            })
        ]).execute();
    }
}
